import './Generator.module.css'

import React from 'react'
import { useCallback, useState, useRef, useEffect, useMemo, RefObject } from 'react'
import { Services } from '@/services/services'
import { useNavigate } from 'react-router-dom'

import { SimpleQR } from '@/services/model/qr'
import { LoggedInPageLayout } from '@/components/layout/LoggedInLayout'
import { CurrentSession } from '@/services/repository/session'
import { BackButton } from '@/components/layout/NavBar'


export const QRGenerator = ({ services, session }: { services: Services, session: CurrentSession }) => {
  const navigate = useNavigate()
  const [qrCode, setQRCode] = useState<SimpleQR>()

  function generate() {
    services.session.fetchWithToken("/api/communal/qr/generator", {
      method: "POST",
    }).then((resp) => {
      return resp.json()
    }).then((data) => {
      setQRCode(data)
    })
  }

  useEffect(() => {
    generate()
  }, [])

  useEffect(() => {
    document.body.classList.add('one-page-print');
    return () => {
      document.body.classList.remove('one-page-print');
    };
  }, []);

  function renderNavigate(qrCode: SimpleQR | undefined) {
    if (qrCode === undefined) {
      {
        return
      }
    }
    return (<div className='nav'>
      <a className='main-btn' onClick={() => generate()}>
        {session.translates.for('page.qr-generator.generate')}
      </a>
      <a className='main-btn' onClick={() => window?.print()}>
        {session.translates.for('page.qr-generator.print')}
      </a>
      <a className='main-btn' href={'/api/communal/qr/img/' + qrCode?.id} download={true}>
        {session.translates.for('page.qr-generator.download')}
      </a>
      {/* <a className='main-btn' onClick={() => navigate(`/qr/tag/${qrCode?.id}`)}>
        {session.translates.for('page.qr-generator.activate')}
      </a> */}
    </div>)
  }

  function renderImage(qrCode: SimpleQR | undefined) {
    if (qrCode === undefined) {
      return (<div className='spinner'></div>)
    }
    return (<img className='qrimage' src={'/api/communal/qr/img/' + qrCode.id} />)
  }

  return <LoggedInPageLayout pageName='qr-generator' services={services} session={session}
    navbarLeft={<BackButton services={services} translates={session.translates} />}>
    <div className='qr-generator content-body'>
      {renderImage(qrCode)}
      {renderNavigate(qrCode)}
    </div>
  </LoggedInPageLayout>
}
